var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Button, Container } from 'reactstrap';
import moment from 'moment';
import BootstrapTheme from '@fullcalendar/bootstrap';
import ModalConfigPrice from './ModalConfigPrice';
import { T } from '../../helpers/i18n';
import theme from '../../Theme';
import { inject } from 'mobx-react';
import { loading } from '../../elements/Loading';
import { getLocaleFullcalendar } from '../../helpers/Format';
import { isSomeWeekdaySelected } from './Utils';
import { isInRange } from '../CalendarAvailable/Utils';
import { DayContentCell } from './DayContentCell';
var PriceCalendar = inject('store')(loading(function (props) {
    var afterDate = moment(new Date).format('YYYY-MM-DD');
    return [
        props.store.passengerCategories.read().then(function (passengerCategories) { return ({ passengerCategories: passengerCategories }); }),
        props.store.datePricesStore.readStretch(afterDate, props.stretch.id).then(function (stretchPriceDates) { return ({ stretchPriceDates: stretchPriceDates }); })
    ];
})(function (props) {
    var store = props.store, reload = props.reload, reset = props.reset, stretch = props.stretch, busy = props.busy, money = props.money, 
    // schedules,
    passengerCategories = props.passengerCategories, onSavePriceClick = props.onSavePriceClick, onReseted = props.onReseted;
    useEffect(function () {
        if (reset) {
            reload();
            resetState();
        }
    }, [reset]);
    // Estado para gestionar la selección de días y rangos
    var _a = useState(null), selectedDay = _a[0], setSelectedDay = _a[1];
    // estado para rango desde
    var _b = useState(null), rangeFrom = _b[0], setRangeFrom = _b[1];
    // const [rangeFrom, setRangeFrom] = useState<Date>(new Date(2025, 4, 12, 0, 0, 0, 0)) // mock
    // estado para rangoFrom
    var _c = useState(null), rangeTo = _c[0], setRangeTo = _c[1];
    // const [rangeTo, setRangeTo] = useState<Date>(new Date(2025, 4, 26, 0, 0, 0, 0)) // mock
    // estado para mostrar modal
    var _d = useState(false), modalVisible = _d[0], setModalVisible = _d[1];
    // estado para días de la semana seleccionados
    var initWeedDaySelected = {
        1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false
    };
    var _e = useState(initWeedDaySelected), weekDaySelected = _e[0], setWeekDaySelected = _e[1];
    // estado para el nuevo rango de precios
    var _f = useState({
        stretchId: null,
        name: '',
        startDate: null,
        endDate: null,
        days: [],
        passengerCategoryId: null,
        scheduleId: null,
        selectedSchedules: [],
        price: 0,
        typePrice: 'primary',
        priority: 0,
        isActive: true,
        description: ''
    }), newPriceRange = _f[0], setNewPriceRange = _f[1];
    // manejo el clic en un día del calendario
    var handleDateClick = function (info) {
        // manejo click de fecha anterior al día actual
        var now = new Date();
        info.date.setHours(23, 59, 59, 999); // para poder clickar en el día actual
        var day = new Date(info.date);
        if (day < now)
            return;
        var clickedDate = new Date(info.dateStr);
        clickedDate.setHours(0, 0, 0, 0);
        // Selección de un solo día
        setSelectedDay(clickedDate);
        setNewPriceRange(__assign(__assign({}, newPriceRange), { startDate: clickedDate, endDate: clickedDate, name: "Precio para ".concat(moment(clickedDate).format('DD/MM/YYYY')) }));
        openModal();
    };
    // para mostrar modal del día
    var openModal = function () {
        setModalVisible(true);
    };
    // para cerrar modal del día
    var closeModal = function () {
        setModalVisible(false);
    };
    // reseteo el estado después de guardar
    var resetState = function () {
        setSelectedDay(null);
        setRangeFrom(null);
        setRangeTo(null);
        setWeekDaySelected(initWeedDaySelected);
        setNewPriceRange({
            stretchId: null,
            name: '',
            startDate: null,
            endDate: null,
            days: [],
            passengerCategoryId: null,
            scheduleId: null,
            selectedSchedules: [],
            price: 0,
            typePrice: 'primary',
            priority: 0,
            isActive: true,
            description: ''
        });
        setModalVisible(false);
        onReseted();
    };
    // manejo la selección de horarios
    var handleScheduleSelection = function (scheduleId) {
        var currentSchedules = __spreadArray([], newPriceRange.selectedSchedules, true);
        var scheduleIndex = currentSchedules.indexOf(scheduleId);
        if (scheduleIndex === -1) {
            // Añadir el horario
            currentSchedules.push(scheduleId);
        }
        else {
            // Quitar el horario
            currentSchedules.splice(scheduleIndex, 1);
        }
        setNewPriceRange(__assign(__assign({}, newPriceRange), { selectedSchedules: currentSchedules }));
    };
    useEffect(function () {
        closeModal();
    }, [rangeFrom, rangeTo]);
    var handleFromClick = function (date) {
        setRangeFrom(date);
    };
    var handleToClick = function (date) {
        if (rangeFrom >= date) {
            return;
        }
        setRangeTo(date);
        setSelectedDay(null);
    };
    var handleClearClick = function () {
        setRangeFrom(null);
        setRangeTo(null);
    };
    var handleWeekDaySelected = function (weekDay) {
        if (weekDay < 0 || weekDay > 7) {
            throw new Error('Week day is out of range');
        }
        var wds = __assign({}, weekDaySelected);
        wds[weekDay] = !wds[weekDay];
        setWeekDaySelected(wds);
    };
    // console.log('render - weekDaySelected[WeekDays.monday]: ', weekDaySelected[WeekDays.monday])
    var handleDayContextMenu = function (date, event, view) {
        event.preventDefault();
        if (!rangeFrom) {
            setRangeFrom(date);
        }
        if (rangeFrom && !rangeTo) {
            if (rangeFrom >= date) {
                return;
            }
            setRangeTo(date);
        }
        if (rangeFrom && rangeTo) {
            resetState();
            setRangeFrom(date);
        }
    };
    var handleDayRender = useCallback(function (info) {
        var now = new Date();
        info.date.setHours(23, 59, 59, 999);
        var day = new Date(info.date);
        // manejo días anteriores al actual
        if (day < now)
            return;
        // manejo días de otro mes
        var othermonth = false;
        if (info.el.className.includes('fc-disabled-day') || info.el.className.includes('fc-other-month')) {
            othermonth = true;
        }
        // valores de fondo y color texto por defecto
        var backColor = theme.color.backgreen, color = 'green';
        // manejo si el día está en el rango seleccionado
        var rangeFromIDay;
        var rangeToIDay;
        if (rangeFrom) {
            rangeFromIDay = {
                day: rangeFrom.getDate(),
                month: rangeFrom.getMonth(),
                year: rangeFrom.getFullYear(),
            };
        }
        if (rangeTo) {
            rangeToIDay = {
                day: rangeTo.getDate(),
                month: rangeTo.getMonth(),
                year: rangeTo.getFullYear(),
            };
        }
        var _isInRange = isInRange(rangeFromIDay, rangeToIDay, info.date);
        if (_isInRange) {
            backColor = theme.color.backblue;
            // manejo si hay algún día de la semana seleccionado
            if (isSomeWeekdaySelected(weekDaySelected)) {
                backColor = 'pink';
            }
            // manejo si es día de la semana seleccionado
            if (weekDaySelected[info.date.getDay()]) {
                backColor = theme.color.backblue;
            }
        }
        var opacity = othermonth ? 0.3 : 1;
        // manejo si el día tiene precio
        var priceDates = props.stretchPriceDates;
        var momentDate = moment(day).format('YYYY-MM-DD');
        var stretchPriceDate = priceDates.filter(function (pd) { return pd.date === momentDate; });
        var content = getContent(stretchPriceDate);
        ReactDOM.render(React.createElement(DayContentCell, { backgroundColor: backColor, color: color, content: content, opacity: opacity, date: day, onContextMenu: handleDayContextMenu }), info.el);
        // info.el.innerHTML = renderDay(backColor, color, content, opacity)
    }, [weekDaySelected, rangeFrom, rangeTo, props.stretchPriceDates /*, handleDayContextMenu*/]);
    return (React.createElement("div", { className: "price-calendar-container" },
        React.createElement("div", { className: "control-panel mb-3" }, rangeFrom && rangeTo && (React.createElement(Container, null,
            React.createElement(Button, { style: styleButtons(WeekDays.monday, weekDaySelected), onClick: function () { return handleWeekDaySelected(WeekDays.monday); } }, T('monday')),
            React.createElement(Button, { style: styleButtons(WeekDays.tuesday, weekDaySelected), onClick: function () { return handleWeekDaySelected(WeekDays.tuesday); } }, T('tuesday')),
            React.createElement(Button, { style: styleButtons(WeekDays.wednesday, weekDaySelected), onClick: function () { return handleWeekDaySelected(WeekDays.wednesday); } }, T('wednesday')),
            React.createElement(Button, { style: styleButtons(WeekDays.thursday, weekDaySelected), onClick: function () { return handleWeekDaySelected(WeekDays.thursday); } }, T('thursday')),
            React.createElement(Button, { style: styleButtons(WeekDays.friday, weekDaySelected), onClick: function () { return handleWeekDaySelected(WeekDays.friday); } }, T('friday')),
            React.createElement(Button, { style: styleButtons(WeekDays.saturday, weekDaySelected), onClick: function () { return handleWeekDaySelected(WeekDays.saturday); } }, T('saturday')),
            React.createElement(Button, { style: styleButtons(WeekDays.sunday, weekDaySelected), onClick: function () { return handleWeekDaySelected(WeekDays.sunday); } }, T('sunday'))))),
        React.createElement(FullCalendar, { locale: getLocaleFullcalendar(), firstDay: 1, plugins: [BootstrapTheme, dayGridPlugin, interactionPlugin], defaultView: "dayGridMonth", 
            // selectable={true}
            dateClick: handleDateClick, dayRender: handleDayRender }),
        selectedDay && React.createElement(ModalConfigPrice, { modalVisible: modalVisible, selectedDay: selectedDay, stretch: stretch, money: money, passengerCategories: passengerCategories, from: rangeFrom, to: rangeTo, weekDaySelected: weekDaySelected, busy: busy, 
            // schedules={schedules}
            onCancelClick: closeModal, resetState: resetState, 
            // onScheduleSelection={handleScheduleSelection}
            onSavePriceClick: onSavePriceClick, onFromClick: handleFromClick, onToClick: handleToClick, onClearClick: handleClearClick })));
}));
var WeekDays = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
};
var styleButtons = function (weekDay, weekDaySelected) {
    return weekDaySelected[weekDay] ? { color: theme.color.primary, backgroundColor: 'white' } : { color: 'black', backgroundColor: 'white' };
};
var getContent = function (stretchPriceDate) {
    if (stretchPriceDate.length > 0) {
        if (stretchPriceDate.length < 3) {
            return (React.createElement("div", { style: { width: '100%', margin: '7px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', alignItems: 'flex-start', alignContent: 'flex-start', gap: '2px' } }, stretchPriceDate.map(function (spd, index) { return (React.createElement(React.Fragment, { key: index },
                React.createElement("div", { style: { backgroundColor: 'whitesmoke', fontSize: 'clamp(7px, 1vw, 12px)', color: 'black' } }, spd.stretchPrice.passengerCategory.name),
                React.createElement("div", { style: { backgroundColor: 'whitesmoke', marginBottom: '2px', fontSize: 'clamp(6px, 1vw, 12px)', color: 'black' } },
                    React.createElement("span", { style: { color: 'red', textDecoration: 'line-through' } }, spd.stretchPrice.price < 0 ? T('disabled') : spd.stretchPrice.price.toFixed(2)),
                    "=> ",
                    spd.price.toFixed(2)))); })));
        }
        else {
            return (React.createElement("div", { style: { width: '100%', margin: '7px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', alignItems: 'flex-start', alignContent: 'flex-start', gap: '2px' } }, stretchPriceDate.map(function (spd, index) { return (React.createElement("div", { key: index, style: { backgroundColor: 'whitesmoke', fontSize: 'clamp(8px, 1vw, 14px)', color: 'black' } }, spd.stretchPrice.passengerCategory.name)); })));
        }
    }
    return null;
};
export default PriceCalendar;



//////////////////
// WEBPACK FOOTER
// ./src/components/PriceCalendar/PriceCalendar.tsx
// module id = 1543
// module chunks = 0